import crossDomainLoginComponent from "@/services/crossDomainLogin.vue";
export default {
	//@ts-ignore
	install(Vue, options) {
		Vue.mixin({
			methods: {
				LoginUser() {
					if (window.frameElement)
						return;

					try {
						var frame = document.getElementById("userFrame");
						if (!frame)
							return;

						var CTC_USER = localStorage.getItem("CTC_USER");
						var CTC_AUTH_TOKEN = localStorage.getItem("CTC_AUTH_TOKEN");
						var CTC_REFRESH_TOKEN = localStorage.getItem("CTC_REFRESH_TOKEN");

						if (CTC_USER && CTC_AUTH_TOKEN && CTC_REFRESH_TOKEN) {
							//@ts-ignore
							frame.contentWindow.postMessage(JSON.stringify({ ACTION: "LOGIN", CTC_USER: CTC_USER, CTC_AUTH_TOKEN: CTC_AUTH_TOKEN, CTC_REFRESH_TOKEN: CTC_REFRESH_TOKEN }), "*");
						}
					}
					catch (err) {
						console.error("Failed to access iframe");
					}
				},
				LogoutUser() {
					if (window.frameElement)
						return;

					try {
						var frame = document.getElementById("userFrame");
						if (!frame)
							return;

						var CTC_USER = localStorage.getItem("CTC_USER");
						var CTC_AUTH_TOKEN = localStorage.getItem("CTC_AUTH_TOKEN");
						var CTC_REFRESH_TOKEN = localStorage.getItem("CTC_REFRESH_TOKEN");

						//@ts-ignore
						frame.contentWindow.postMessage(JSON.stringify({ ACTION: "LOGOUT", CTC_USER: CTC_USER, CTC_AUTH_TOKEN: CTC_AUTH_TOKEN, CTC_REFRESH_TOKEN: CTC_REFRESH_TOKEN }), "*");

					}
					catch (err) {
						console.error("Failed to access iframe");
					}
				},
				LoginCTC() {
					if (window.frameElement)
						return;

					try {
						var frame = document.getElementById("ctcFrame");
						if (!frame)
							return;

						var CTC_USER = localStorage.getItem("CTC_USER");
						var CTC_AUTH_TOKEN = localStorage.getItem("CTC_AUTH_TOKEN");
						var CTC_REFRESH_TOKEN = localStorage.getItem("CTC_REFRESH_TOKEN");

						if (CTC_USER && CTC_AUTH_TOKEN && CTC_REFRESH_TOKEN) {
							//@ts-ignore
							frame.contentWindow.postMessage(JSON.stringify({ ACTION: "LOGIN", CTC_USER: CTC_USER, CTC_AUTH_TOKEN: CTC_AUTH_TOKEN, CTC_REFRESH_TOKEN: CTC_REFRESH_TOKEN }), "*");
						}
					}
					catch (err) {
						console.error("Failed to access iframe");
					}
				},
				LogoutCTC() {
					if (window.frameElement)
						return;

					try {
						var frame = document.getElementById("ctcFrame");
						if (!frame)
							return;

						var CTC_USER = localStorage.getItem("CTC_USER");
						var CTC_AUTH_TOKEN = localStorage.getItem("CTC_AUTH_TOKEN");
						var CTC_REFRESH_TOKEN = localStorage.getItem("CTC_REFRESH_TOKEN");


						//@ts-ignore
						frame.contentWindow.postMessage(JSON.stringify({ ACTION: "LOGOUT", CTC_USER: CTC_USER, CTC_AUTH_TOKEN: CTC_AUTH_TOKEN, CTC_REFRESH_TOKEN: CTC_REFRESH_TOKEN }), "*");

					}
					catch (err) {
						console.error("Failed to access iframe");
					}
				}
			},
			created() {
				try {
					document.domain = 'awg.aero';
				}
				catch (err) { }
				Vue.component("cross-domain", crossDomainLoginComponent);
			},
			mounted() {
				Vue.prototype.$login = {
					users: this.LoginUser,
					ctc: this.LoginCTC
				};
				Vue.prototype.$logout = {
					users: this.LogoutUser,
					ctc: this.LogoutCTC
				};
			}
		});
	}
}
